// extracted by mini-css-extract-plugin
export var actionButton = "_lz-t";
export var buttonContainer = "_lz-0";
export var buttonContainer2 = "_lz-1";
export var buttonSection = "_lz-2";
export var details = "_lz-3";
export var dropdownItem = "_lz-5";
export var dropdownItemsContainer = "_lz-4";
export var fileInput = "_lz-r";
export var headerButton = "_lz-6";
export var icon = "_lz-7";
export var input = "_lz-8";
export var macroListItem = "_lz-9";
export var mainContent = "_lz-a";
export var microText = "_lz-b";
export var modal = "_lz-w";
export var optionsButton = "_lz-c";
export var paperclip = "_lz-s";
export var pillContent = "_lz-d";
export var preview = "_lz-e";
export var preview2 = "_lz-f";
export var quillEditor = "_lz-q";
export var selectedMacro = "_lz-g";
export var sidebar = "_lz-h";
export var sidebarHeader = "_lz-j";
export var sidebarList = "_lz-i";
export var sidebarListItem = "_lz-k";
export var sidebarSearch = "_lz-l";
export var snoozeDurationWrapper = "_lz-v";
export var statusPillContainer = "_lz-m";
export var tagsContainer = "_lz-n";
export var unselectedMacro = "_lz-o";
export var variable = "_lz-u";
export var wrapper = "_lz-p";